export default "__VITE_ASSET__Ujan$7Op__"